export enum CoordinationStatusTextEnum {
    COORDINATION_UNKNOWN = 'Unknown',
    COORDINATION_CREATED = 'Created',
    COORDINATION_REMOVED = 'Removed',
    COORDINATION_PENDING_ACCEPTANCE = 'Pending Acceptance',
    COORDINATION_PENDING_REVIEW = 'Pending Review',
    COORDINATION_APPROVED = 'Approved',
    COORDINATION_COORDINATED = 'Coordinated',
    COORDINATION_ACTIVATED = 'Activated',
    COORDINATION_DEACTIVATED = 'Deactivated',
    COORDINATION_FINISHED = 'Finished',
    COORDINATION_CANCELLING = 'Cancelling',
    COORDINATION_CANCELLED = 'Cancelled',
    COORDINATION_SUSPENDING = 'Suspending',
    COORDINATION_SUSPENDED = 'Suspended',
    COORDINATION_REJECTED = 'Rejected',
    COORDINATION_UNDERTEST = 'Under Test',
  }